(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9730],{

/***/ 7433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/ebay-shipping-guide/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-02-22",
      tag: "eBay",
      title: "eBay Shipping Guide for Sellers",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Selling on eBay can be an effective and one of the most well-known ways to make money online. Although shipping policies and practices can be intimidating to first-time sellers online, eBay shipping is not as difficult as you initially thought. Millions of eBay sellers ship packages from their homes every day, and here's what you need to know to be able to do this too."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Shipping and delivery options"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Not all items are the same, which means that not all items will cost the same to ship. When calculating the shipping and delivery cost, size, weight, and many other factors come into play. What's important is that you always consider your shipping options and practices accordingly before closing sales."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Ask yourself questions like how much does this item weigh? Does it need a box? Will it need any extra packaging for cushioning? This is because depending on what you're selling, it is always an advantage to keep a variety of boxes on hand to ship on the go with varied items of shapes, sizes, and weights."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Integrated shipping carriers"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Sending items to your buyers come in different ways. Offering more than one delivery option will let you attract many different types of buyers. This is made easier by eBay because it offers buyers economy or expedited shipping from all major domestic carriers and has integrated shipping carriers that sellers can choose from."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "It works after your item sells. You can also select the \"eBay international standard\" option when printing eBay Labels for buyers outside of the US. This lets you drop off your package at any US post office or schedule a pick-up."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Shipping rates and discounts"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "One way to retain buyers and grow your business is to offer free shipping or reduce delivery charges as much as you can."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Now take note that if you're offering a flat rate shipping cost, where all buyers pay the same amount, two different types of shipping rules can be applied:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "You can add a fixed amount each time your buyer adds another item in their purchase. For example, the first item's shipping fee is $5. You may add a $2 shipping fee for each additional item purchased."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "You can subtract an amount from the shipping fee each time the buyer adds another item to purchase. For instance, you could choose to lessen $1 from the initial cost (i.e., $4) for each additional purchase."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "If you haven't already created a flat shipping rule, here's how:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "On the Manage shipping settings page, select Edit beside Flat shipping rule."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Select whether to add or subtract an amount from the dropdown menu for each additional item purchased."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Enter the amount to add/subtract."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Select Save."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Now, as for how shipping discounts work, you first need to offer combined shipping before you can offer discounted shipping to buyers who buy more than one item from you. And depending on whether you offer a flat shipping rate or use calculated shipping discounts, it works differently."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "To check that combined payments are enabled on your account:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Go to the Manage shipping settings page."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Select Edit (beside Allow combined payments and shipping)"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Choose when you're willing to combine payment for purchased items and select Save."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Selling internationally"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "eBay Internation shipping is made easier and more convenient with Easyship. This tool saves eBay merchants money with eBay's pre-negotiated rates. So the idea is for sellers to save up to 70% off shipping with any courier worldwide. For example, you have to ship a 3-pound package from the United States to China. Instead of going through multiple shipping couriers to get the best rates, Easyship has a free shipping rate calculator to make your life easier. As for shipping options, you can choose from UPS Worldwide Expedited with two days business days for delivery or SF express shipping and APC among many couriers."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Packaging and tracking"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "After you've sold your item, one of the best parts for many is packaging it, and you must pack it securely. With the right type of packaging, you make sure that your buyer receives their order in good condition."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Packaging tips you need to know as a seller:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Choose a container that's slightly larger than your item to be able to cushion the item with packing material on all sides."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Surround your item with bubble wrap, packing peanuts, foam, or paper."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Use clear or brown packaging tape, which should be at least 2 inches wide."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Securely tape the opening of the box and reinforce all seams and edges."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Make sure to label the package clearly and include a return address."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Alternatively, you may also opt to use eBay branded packaging to give your order a more professional look. You can get branded packaging at the shipping supplies store."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "When it comes to tracking your package, you can easily do this online to your shipping address when you upload the tracking information. If you're using a tracked shipping service, you can see the carrier information and your order's current location, which is helpful when providing your buyer with real-time updates."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Returns for sellers"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "eBay has a money-back guarantee that buyers will be refunded should their item fail to match the seller's description or if it arrived damaged or defective. Returns have to be processed within 30 days upon receiving the item or longer if the seller has an extended return window. This means sellers will have to offer a minimum 14 days return policy. And refund the original postage costs if the item is damaged or faulty. And once a return is requested, you have eight days to respond, and when you receive a returned item, you have six days to issue a refund."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/ebay-shipping-guide.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "eBay Shipping Guide for Sellers"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Avoid making shipping mistakes at eBay and know the best shipping practices to minimize returns!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/ebay-shipping-guide"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/ebay-shipping-guide"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "eBay Shipping Guide for Sellers"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Avoid making shipping mistakes at eBay and know the best shipping practices to minimize returns!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "February 22nd, 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "February 22nd, 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "eBay"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 25966:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/ebay-shipping-guide",
      function () {
        return __webpack_require__(7433);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(25966); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);